var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProviders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.00007C14.4853 9.00007 16.5 6.98533 16.5 4.50003C16.5 2.01473 14.4853 0 12 0C9.51472 0 7.5 2.01473 7.5 4.50003C7.5 6.98533 9.51472 9.00007 12 9.00007Z",
    fill: "#009FD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 11.2501C5.23896 11.2501 6.75 9.73903 6.75 7.87506C6.75 6.01108 5.23896 4.50003 3.375 4.50003C1.51104 4.50003 0 6.01108 0 7.87506C0 9.73903 1.51104 11.2501 3.375 11.2501Z",
    fill: "#009FD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.87506C24 9.73903 22.489 11.2501 20.625 11.2501C18.761 11.2501 17.25 9.73903 17.25 7.87506C17.25 6.01108 18.761 4.50003 20.625 4.50003C22.489 4.50003 24 6.01108 24 7.87506Z",
    fill: "#009FD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.6615C3.75 13.2582 3.83034 12.87 3.97731 12.5143C3.16611 12.5602 2.35952 12.7133 1.579 12.9735C0.636037 13.2878 0 14.1703 0 15.1642V15.2529C0 16.5704 0.267622 17.8743 0.786635 19.0853L1.36368 20.4318C1.90137 21.6864 3.13502 22.4999 4.5 22.4999C5.22016 22.4999 5.90376 22.2734 6.46788 21.8752C6.37791 21.7354 6.29491 21.5899 6.21948 21.4391L5.01687 19.0338C4.18374 17.3675 3.75 15.5244 3.75 13.6615Z",
    fill: "#009FD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5312 21.8752C18.0954 22.2734 18.779 22.4999 19.4991 22.4999C20.8641 22.4999 22.0978 21.6864 22.6355 20.4318L23.2125 19.0853C23.7315 17.8743 23.9991 16.5704 23.9991 15.2529V15.1642C23.9991 14.1703 23.3631 13.2878 22.4201 12.9735C21.6396 12.7133 20.833 12.5602 20.0218 12.5143C20.1688 12.87 20.2491 13.2582 20.2491 13.6615C20.2491 15.5244 19.8154 17.3675 18.9823 19.0338L17.7797 21.4391C17.7042 21.5899 17.6212 21.7354 17.5312 21.8752Z",
    fill: "#009FD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27239 10.6818C6.93689 11.0157 6 12.2156 6 13.5923V14.1889C6 15.7156 6.2913 17.2282 6.85828 18.6457L7.88583 21.2145C8.55875 22.8969 10.1881 24 12 24C13.8119 24 15.4413 22.8969 16.1142 21.2145L17.1417 18.6457C17.7087 17.2282 18 15.7156 18 14.1889V13.5923C18 12.2156 17.0631 11.0157 15.7276 10.6818L14.9104 10.4775C12.9995 9.99978 11.0005 9.99978 9.08957 10.4775L8.27239 10.6818Z",
    fill: "#009FD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProviders);
export default __webpack_public_path__ + "static/media/icon-providers.85d8768766aaf3f62eea93254945032e.svg";
export { ForwardRef as ReactComponent };